import { useLayoutEffect } from 'react';

import useNavbarToggle from 'lib/hooks/useNavbarToggle';

/**
 * useExpandCollapseNavbar
 *
 * React hook that collapses the navbar on mount and expands it on unmount.
 */
export const useExpandCollapseNavbar = () => {
  const [_, { collapseNavbar, expandNavbar }] = useNavbarToggle();

  useLayoutEffect(() => {
    collapseNavbar();
    return () => {
      expandNavbar();
    };
  }, [collapseNavbar, expandNavbar]);
};
